import React, { useState, useEffect } from 'react';
import { FaPlus } from "react-icons/fa6";
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';

const SingleCountry = () => {
  const { id } = useParams();
  const [statuses, setStatuses] = useState(['']);
  const [formData, setFormData] = useState({
    country_name: '',
     country_code: '',
    monthly_living_cost: '',
    visa_requirement: '',
    part_time_work_details: '',
    country_benefits: '',
    step_1: '',
    step_2: '',
    step_3: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const response = await axios.get(`https://bmrbackend.dynastymaker.com/api/countries/${id}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        
        const countryData = response.data.data;
        
        // Split application steps into array
        const steps = countryData.application_steps?.split(',') || [];
        
        // Set form data
        setFormData({
          country_name: countryData.country_name || '',
          country_code: countryData.country_code || '',
          monthly_living_cost: countryData.monthly_living_cost || '',
          visa_requirement: countryData.visa_requirement || '',
          part_time_work_details: countryData.part_time_work_details || '',
          country_benefits: countryData.country_benefits || '',
          step_1: steps[0]?.trim() || '',
          step_2: steps[1]?.trim() || '',
          step_3: steps[2]?.trim() || ''
        });
        
        // Set additional steps (if any)
        if (steps.length > 3) {
          setStatuses(steps.slice(3).map(step => step.trim()));
        }
        
      } catch (error) {
        console.error('Error fetching country data:', error);
        toast.error('Failed to load country data');
      } finally {
        setLoading(false);
      }
    };

    fetchCountryData();
  }, [id]);



  if (loading) {
    return (
      <div className="container py-4">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      {/* View Country Section */}
      <div className='d-flex align-items-center justify-content-center'>
        <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
          View Country
        </div>
      </div>
      <div className="card mb-4 shadow-sm">
        
        <div className="card-body">
            <div className='text-end'>
                <Link to={`/super-admin/edit-country/${id}`} className='btn btn-primary '>Edit</Link>
            </div>
          <div className="mb-3">
            <label>Country Name</label>
           <div className='border px-2 rounded' style={{ display: 'flex', alignItems: 'center', gap: '10px',  background:'#DADADA' }}>
  <img
    src={`https://flagsapi.com/${formData.country_code}/flat/32.png`}
    alt="flag"
    style={{ width: '32px', height: '24px' }}
    onError={(e) => {
      e.target.onerror = null; 
      e.target.src = 'https://flagsapi.com/US/flat/32.png';
    }}
  />
  <input
    type="text"
    className="form-control border-0 bg-transparent"
    value={formData.country_name}
    disabled
    readOnly
  />
</div>
          </div>
          <div className="mb-3">
            <label>Monthly Living Cost</label>
            <input 
              type="text" 
              className="form-control" 
              name="monthly_living_cost"
              value={formData.monthly_living_cost}
              disabled
            />
          </div>
          <div className="mb-3">
            <label>Visa Requirement</label>
            <input 
              type="text" 
              className="form-control" 
              name="visa_requirement"
              value={formData.visa_requirement}
              disabled
            />
          </div>
          <div className="mb-3">
            <label>Part Time Work Details</label>
            <input 
              type="text" 
              className="form-control" 
              name="part_time_work_details"
              value={formData.part_time_work_details}
              disabled
            />
          </div>
          <div className="mb-3">
            <label>Country Benefits</label>
            <input 
              type="text" 
              className="form-control" 
              name="country_benefits"
              value={formData.country_benefits}
              disabled
            />
          </div>
        </div>
      </div>

      {/* View Application Process Section */}
      <div className='d-flex align-items-center justify-content-center'>
        <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
          Application Process
        </div>
      </div>
      
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="mb-3">
            <label>Step 01</label>
            <input 
              type="text" 
              className="form-control" 
              name="step_1"
              value={formData.step_1}
              disabled
            />
            <label>Step 02</label>
            <input 
              type="text" 
              className="form-control" 
              name="step_2"
              value={formData.step_2}
              disabled
            />
            <label>Step 03</label>
            <input 
              type="text" 
              className="form-control" 
              name="step_3"
              value={formData.step_3}
              disabled
            />
          </div>

          {statuses.map((status, index) => (
            <div className="mb-3" key={index}>
              <label>Status 0{index + 4}</label>
              <input
                type="text"
                className="form-control"
                value={status}
                disabled
              />
            </div>
          ))}

          <div className="mt-3">
            <Link to={'/super-admin/country'} type="button" className="btn bg-light buttonadd">
              <IoArrowUndoSharp size={20} /> Back
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleCountry;